import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, Star, StarHalf, ShieldCheck, ChevronDown, ChevronLeft, ChevronRight, Battery, Lightbulb, Clock, BrainCircuit, Target, XCircle, BookOpen, Calendar, Zap, HeartPulse, CheckSquare, Rocket, Headphones, Users, Lock, Circle, Flame, Timer } from 'lucide-react';
import { PurchasePopup } from '../components/PurchasePopup';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/8ZwAo6mkXw2ycicN6MmZXG/ChatGPT_Image_10_jun_2026,_15_57_11_(2).png';
const scrollToPricing = (e: React.MouseEvent) => {
  e.preventDefault();
  const element = document.getElementById('compra');
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth'
    });
  }
};
const textureClass = 'bg-[radial-gradient(rgba(255,255,255,0.08)_1px,transparent_1px)] bg-[size:16px_16px]';
export function LandingPage() {
  const [selectedPlan, setSelectedPlan] = useState<'standard' | 'advanced'>('advanced');
  return <div className="min-h-screen font-['Montserrat',sans-serif] bg-gray-50 text-gray-800 overflow-x-hidden" data-id="element-17">
      <PurchasePopup data-id="element-18" />

      {/* 1. HERO SECTION */}
      <section className="bg-[#0a1733] text-white pt-5 pb-8 md:pt-16 md:pb-20 px-4 relative overflow-hidden" data-id="element-19">
        <div className={`absolute inset-0 ${textureClass}`} data-id="element-20"></div>
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#e0b73c] via-transparent to-transparent" data-id="element-21"></div>

        <div className="max-w-5xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 bg-[#0d1f47] border border-[#e0b73c]/30 px-3 py-1 md:px-4 md:py-1.5 rounded-full text-[10px] leading-tight md:text-sm font-medium text-[#e0b73c] mb-3 md:mb-6" data-id="element-23">
            <Star className="w-3 h-3 md:w-4 md:h-4 fill-current flex-shrink-0" data-id="element-24" />
            Sistema N°1 para Recuperar tu Energía y Enfoque
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.1
        }} className="text-2xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-3 md:mb-8 text-white" data-id="element-25">
            MegaPack Motivación Total
          </motion.h1>

          <motion.div animate={{
          y: [0, -12, 0],
          filter: ['drop-shadow(0px 10px 15px rgba(224,183,60,0.15))', 'drop-shadow(0px 25px 25px rgba(224,183,60,0.35))', 'drop-shadow(0px 10px 15px rgba(224,183,60,0.15))']
        }} transition={{
          duration: 4.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-[55%] max-w-[180px] md:max-w-[320px] mx-auto mb-4 md:mb-8 cursor-pointer relative z-20" onClick={scrollToPricing} data-id="element-26">
            <img src={PRODUCT_IMAGE} alt="MegaPack Motivación Total" className="w-full" data-id="element-27" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="flex flex-col items-center" data-id="element-28">
            <p className="text-sm md:text-xl text-[#e0b73c] font-semibold mb-2 md:mb-4" data-id="element-29">
              6 Tomos + 6 Bonos — PDF Digital · Acceso Inmediato
            </p>

            <p className="text-xs md:text-lg text-gray-300 max-w-2xl mb-4 md:mb-8 leading-relaxed px-2" data-id="element-30">
              Métodos, rutinas y herramientas prácticas para activar tu
              motivación, mantener tu disciplina y vencer la procrastinación.
              Sin excusas. Sin desgano.
            </p>

            <button onClick={scrollToPricing} className="bg-gradient-to-r from-[#e0b73c] to-[#c9a227] hover:from-[#f0c74c] hover:to-[#d9b237] text-[#0a1733] text-base md:text-2xl font-bold py-3.5 px-6 md:px-8 rounded-full shadow-[0_0_30px_rgba(224,183,60,0.4)] hover:shadow-[0_0_40px_rgba(224,183,60,0.6)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 w-full max-w-lg" data-id="element-31">
              💥 QUIERO MI MEGAPACK AHORA
            </button>

            <div className="flex flex-wrap justify-center gap-3 md:gap-6 mt-4 md:mt-6 text-[10px] md:text-sm font-medium text-gray-300" data-id="element-32">
              <div className="flex items-center gap-1.5" data-id="element-33">
                <ShieldCheck className="w-4 h-4 md:w-5 md:h-5 text-[#e0b73c]" data-id="element-34" />{' '}
                Garantía 7 días
              </div>
              <div className="flex items-center gap-1.5" data-id="element-35">
                <Users className="w-4 h-4 md:w-5 md:h-5 text-[#e0b73c]" data-id="element-36" /> +1000
                Usuarios Satisfechos
              </div>
              <div className="flex items-center gap-1.5" data-id="element-37">
                <Star className="w-4 h-4 md:w-5 md:h-5 fill-[#e0b73c] text-[#e0b73c]" data-id="element-38" />{' '}
                4.9 Rating
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 2. TESTIMONIALS */}
      <section className="py-10 md:py-16 px-4 bg-white" data-id="element-39">
        <div className="max-w-6xl mx-auto" data-id="element-40">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-41">
            <h2 className="text-2xl md:text-4xl font-bold text-[#0a1733] mb-3" data-id="element-42">
              +1000 PERSONAS YA TRANSFORMARON SU ENERGÍA
            </h2>
            <p className="text-base md:text-lg text-gray-600" data-id="element-43">
              Lo que dicen quienes ya aplicaron el MegaPack
            </p>
          </motion.div>

          <TestimonialCarousel data-id="element-44" />
        </div>
      </section>

      {/* 3. VISTA PREVIA */}
      <section className="py-10 md:py-16 px-4 bg-[#0d1f47] text-white text-center relative" data-id="element-45">
        <div className={`absolute inset-0 ${textureClass}`} data-id="element-46"></div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto relative z-10" data-id="element-47">
          <h2 className="text-2xl md:text-4xl font-bold text-[#e0b73c] mb-3" data-id="element-48">
            VISTA PREVIA
          </h2>
          <h3 className="text-xl md:text-2xl font-semibold mb-3" data-id="element-49">
            Descubre el interior del MegaPack Motivación Total
          </h3>
          <p className="text-sm md:text-base text-gray-300 mb-8 max-w-2xl mx-auto px-2" data-id="element-50">
            Conoce la calidad de nuestras guías, herramientas y rutinas
            diseñadas para transformar tu motivación desde el primer día.
          </p>
          <motion.div whileHover={{
          scale: 1.03
        }} className="cursor-pointer max-w-xl mx-auto rounded-xl overflow-hidden shadow-2xl border border-[#e0b73c]/20" onClick={scrollToPricing} data-id="element-51">
            <video src="https://cdn.magicpatterns.com/uploads/npSmZ1go5gDisBbjrHHKzM/SCREENRECORDINGMEGAPACKMOTIVACIONAL.mov" className="w-full h-auto" autoPlay loop muted playsInline data-id="element-52" />
          </motion.div>
        </motion.div>
      </section>

      {/* 4. LA REALIDAD HOY (Pain Points) */}
      <section className="py-10 md:py-16 px-4 bg-gray-50" data-id="element-53">
        <div className="max-w-5xl mx-auto" data-id="element-54">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-55">
            <h2 className="text-2xl md:text-4xl font-bold text-[#0a1733] mb-3" data-id="element-56">
              LA REALIDAD HOY
            </h2>
            <p className="text-lg md:text-xl text-gray-600 font-medium" data-id="element-57">
              ¿Te suena familiar?
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 mb-10" data-id="element-58">
            <PainCard icon="😓" text="Sin energía para empezar el día" delay={0.1} data-id="element-59" />
            <PainCard icon="💭" text="Ideas y proyectos que no avanzan" delay={0.2} data-id="element-60" />
            <PainCard icon="⏳" text="Postergas tareas importantes y sientes culpa" delay={0.3} data-id="element-61" />
            <PainCard icon="😰" text="Ansiedad o estrés por falta de resultados" delay={0.4} data-id="element-62" />
            <PainCard icon="🧠" text="Te dispersas fácilmente y no logras enfocarte" delay={0.5} data-id="element-63" />
            <PainCard icon="📉" text="Pierdes oportunidades por falta de disciplina" delay={0.6} data-id="element-64" />
            <PainCard icon="❌" text="Te sientes atrapado en un círculo de desgano" className="md:col-span-2 lg:col-span-3 max-w-md mx-auto w-full" delay={0.7} data-id="element-65" />
          </div>

          <div className="text-center" data-id="element-66">
            <button onClick={scrollToPricing} className="bg-[#0a1733] hover:bg-[#0d1f47] text-white text-base md:text-lg font-bold py-3 md:py-4 px-6 md:px-8 rounded-full shadow-lg transition-all transform hover:-translate-y-1 inline-flex items-center gap-2" data-id="element-67">
              QUIERO CAMBIAR ESTA REALIDAD{' '}
              <ChevronDown className="w-4 h-4 md:w-5 md:h-5 text-[#e0b73c]" data-id="element-68" />
            </button>
          </div>
        </div>
      </section>

      {/* 5. ¿PARA QUIÉN ES? */}
      <section className="py-10 md:py-16 px-4 bg-white" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto" data-id="element-70">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-[#0a1733] mb-6 md:mb-10" data-id="element-71">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-center text-base md:text-lg text-gray-600 mb-6 md:mb-8" data-id="element-72">
            Diseñado especialmente para quienes quieren:
          </p>

          <div className="space-y-3 md:space-y-4 mb-8 md:mb-10" data-id="element-73">
            <TargetAudienceItem text="Profesionales y emprendedores que buscan mantener energía y productividad." data-id="element-74" />
            <TargetAudienceItem text="Estudiantes que deben mejorar concentración y cumplir metas académicas." data-id="element-75" />
            <TargetAudienceItem text="Freelancers y creativos que desean vencer la procrastinación y mantenerse motivados." data-id="element-76" />
            <TargetAudienceItem text="Cualquier persona que quiera dejar atrás la falta de foco y recuperar su bienestar emocional." data-id="element-77" />
          </div>

          <div className="bg-[#e0b73c]/10 border border-[#e0b73c]/30 rounded-xl p-5 md:p-6 text-center" data-id="element-78">
            <p className="text-lg md:text-xl font-bold text-[#0a1733]" data-id="element-79">
              Si quieres resultados medibles en pocas semanas, este MegaPack es
              para ti.
            </p>
          </div>
        </motion.div>
      </section>

      {/* 6. STATS ROW */}
      <section className="py-10 md:py-12 px-4 bg-[#0a1733] text-white border-y border-[#e0b73c]/20 relative" data-id="element-80">
        <div className={`absolute inset-0 ${textureClass}`} data-id="element-81"></div>
        <div className="max-w-6xl mx-auto text-center relative z-10" data-id="element-82">
          <h2 className="text-xl md:text-3xl font-bold text-[#e0b73c] mb-8 md:mb-10 px-2" data-id="element-83">
            EL MEGAPACK MÁS COMPLETO PARA RECUPERAR TU MOTIVACIÓN
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-84">
            <StatItem number="+300" text="Páginas" data-id="element-85" />
            <StatItem number="+12" text="Rutinas y plantillas" data-id="element-86" />
            <StatItem number="6" text="Tomos" data-id="element-87" />
            <StatItem number="6" text="Bonos" data-id="element-88" />
          </div>
        </div>
      </section>

      {/* 7. CONTENIDO COMPLETO (Tomos) */}
      <section className="py-10 md:py-16 px-4 bg-gray-50" data-id="element-89">
        <div className="max-w-6xl mx-auto" data-id="element-90">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-91">
            <h2 className="text-2xl md:text-4xl font-bold text-[#0a1733] mb-2 md:mb-4" data-id="element-92">
              CONTENIDO COMPLETO
            </h2>
            <h3 className="text-xl md:text-2xl font-bold text-[#e0b73c] mb-2" data-id="element-93">
              LOS 6 TOMOS
            </h3>
            <p className="text-base md:text-lg text-gray-600" data-id="element-94">
              Tu hoja de ruta para energía, enfoque y disciplina diaria
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6" data-id="element-95">
            <TomoCard num="1" title="Fundamentos de la Motivación Interna" image="https://cdn.magicpatterns.com/uploads/tjDusc9S2TxVimP3QWVuf8/Tomo_1_Fundamentos_de_la_Motivacion_Interna_Activa_tus_circuitos_naturales_de_energia_para_empezar_cada_dia_con_fuerza..png" desc="Descubre cómo funciona la motivación desde la raíz y aprende a generar impulso propio sin depender de circunstancias externas. Comprenderás los mecanismos mentales que te ayudan a iniciar acciones y mantener la constancia." icon={<Battery className="w-5 h-5 md:w-6 md:h-6 text-[#e0b73c]" data-id="element-97" />} delay={0.1} data-id="element-96" />
            <TomoCard num="2" title="Rutinas Poderosas para un Día Productivo" image="https://cdn.magicpatterns.com/uploads/v1jv8UbB1iixYmjAUGLng4/Tomo_2_Rutinas_Poderosas_para_un_Dia_Productivo_Pasos_sencillos_para_mantener_el_foco_y_avanzar_sin_distracciones..png" desc="Aprende a estructurar tus mañanas y jornadas para aprovechar mejor tu tiempo. Implementarás hábitos prácticos que aumentan tu enfoque, reducen las distracciones y facilitan el cumplimiento de tus tareas diarias." icon={<Clock className="w-5 h-5 md:w-6 md:h-6 text-[#e0b73c]" data-id="element-99" />} delay={0.2} data-id="element-98" />
            <TomoCard num="3" title="Manejo Emocional para Vencer la Procrastinación" image="https://cdn.magicpatterns.com/uploads/jyUy4f2hEvitLb1pMjV1ev/Tomo_3_Manejo_Emocional_para_Vencer_la_Procrastinacion_Aprende_a_dominar_la_flojera_y_administrar_el_estres_para_mantener_tu_motivacion..png" desc="Identifica los bloqueos emocionales que te llevan a postergar y descubre estrategias para gestionar el estrés, la frustración y la falta de ánimo. Desarrollarás una mentalidad más estable para actuar incluso en los días difíciles." icon={<BrainCircuit className="w-5 h-5 md:w-6 md:h-6 text-[#e0b73c]" data-id="element-101" />} delay={0.3} data-id="element-100" />
            <TomoCard num="4" title="Creando Hábitos que Sostienen tu Éxito" image="https://cdn.magicpatterns.com/uploads/1LS7kXGa9Q9iG6KE7B4s7V/Tomo_4_Creando_Habitos_que_Sostienen_tu_Exito_Como_convertir_la_disciplina_en_parte_natural_de_tu_vida..png" desc="Conoce los principios que permiten construir hábitos duraderos y eliminar conductas que limitan tu progreso. Aprenderás cómo crear sistemas simples que te ayuden a avanzar de forma constante hacia tus objetivos." icon={<Target className="w-5 h-5 md:w-6 md:h-6 text-[#e0b73c]" data-id="element-103" />} delay={0.4} data-id="element-102" />
            <TomoCard num="5" title="Alimentación y Movimiento para Energía Constante" image="https://cdn.magicpatterns.com/uploads/bndjcza8xZoXrD689hknyg/Tomo_5_Alimentacion_y_Movimiento_para_Energia_Constante_Pequenos_cambios_que_impactan_tu_bienestar_fisico_y_mental..png" desc="Descubre cómo pequeñas mejoras en tu alimentación, descanso y actividad física pueden influir directamente en tu energía, concentración y rendimiento diario. Todo explicado de forma práctica y fácil de aplicar." icon={<HeartPulse className="w-5 h-5 md:w-6 md:h-6 text-[#e0b73c]" data-id="element-105" />} delay={0.5} data-id="element-104" />
            <TomoCard num="6" title="Planificación Inteligente para Cumplir tus Metas" image="https://cdn.magicpatterns.com/uploads/rJu6hTsTEKfoQZ9utzrJY5/Tomo_6_Planificacion_Inteligente_para_Cumplir_tus_Metas_Herramientas_para_organizar_y_ejecutar_con_efectividad_cada_dia._-.png" desc="Aprende a transformar objetivos generales en planes de acción claros y ejecutables. Utilizarás métodos de organización, priorización y seguimiento para mantener el rumbo y lograr avances medibles cada semana." icon={<Calendar className="w-5 h-5 md:w-6 md:h-6 text-[#e0b73c]" data-id="element-107" />} delay={0.6} data-id="element-106" />
          </div>
        </div>
      </section>

      {/* 8. BONOS */}
      <section className="py-10 md:py-16 px-4 bg-[#0d1f47] text-white relative overflow-hidden" data-id="element-108">
        <div className={`absolute inset-0 ${textureClass}`} data-id="element-109"></div>
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#e0b73c] opacity-5 rounded-full blur-3xl" data-id="element-110"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#e0b73c] opacity-5 rounded-full blur-3xl" data-id="element-111"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-112">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-113">
            <div className="inline-block bg-red-600 text-white text-sm md:text-base font-bold px-4 md:px-6 py-1.5 md:py-2 rounded-full mb-4 md:mb-6 animate-pulse shadow-[0_0_15px_rgba(220,38,38,0.5)]" data-id="element-114">
              🎁 GRATIS SOLO POR HOY
            </div>
            <h2 className="text-2xl md:text-4xl font-bold text-[#e0b73c] mb-3" data-id="element-115">
              INCLUIDOS GRATIS
            </h2>
            <p className="text-base md:text-xl text-gray-300 px-2" data-id="element-116">
              6 Bonos Exclusivos que potencian tu transformación sin costos
              adicionales
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-10" data-id="element-117">
            <BonoCard title="Checklist Diarios Personalizados" desc="Organiza tus acciones clave para no perder el ritmo." icon={<CheckSquare className="w-5 h-5 md:w-6 md:h-6" data-id="element-119" />} delay={0.1} data-id="element-118" />
            <BonoCard title="Mini Guía Rápida Anti-Procrastinación" desc="Técnicas express para vencer la postergación." icon={<Rocket className="w-5 h-5 md:w-6 md:h-6" data-id="element-121" />} delay={0.2} data-id="element-120" />
            <BonoCard title="Plantillas para Seguimiento de Hábitos" desc="Lleva control fácil y visual de tus avances." icon={<Calendar className="w-5 h-5 md:w-6 md:h-6" data-id="element-123" />} delay={0.3} data-id="element-122" />
            <BonoCard title="Audio Mindfulness para Concentración" desc="Meditaciones guiadas descargables para calmar la mente." icon={<Headphones className="w-5 h-5 md:w-6 md:h-6" data-id="element-125" />} delay={0.4} data-id="element-124" />
            <BonoCard title="Ejercicios Prácticos de Neuroactivación" desc="Técnicas sencillas para activar tu enfoque al instante." icon={<Zap className="w-5 h-5 md:w-6 md:h-6" data-id="element-127" />} delay={0.5} data-id="element-126" />
            <BonoCard title="Acceso a Comunidad Privada" desc="Comparte tu proceso, recibe motivación y apoyo constante." icon={<Users className="w-5 h-5 md:w-6 md:h-6" data-id="element-129" />} delay={0.6} data-id="element-128" />
          </div>

          <div className="text-center" data-id="element-130">
            <button onClick={scrollToPricing} className="bg-gradient-to-r from-[#e0b73c] to-[#c9a227] hover:from-[#f0c74c] hover:to-[#d9b237] text-[#0a1733] text-base md:text-xl font-bold py-3 md:py-4 px-6 md:px-8 rounded-full shadow-[0_0_20px_rgba(224,183,60,0.3)] transition-all transform hover:-translate-y-1 inline-flex items-center gap-2" data-id="element-131">
              QUIERO MIS BONOS GRATIS{' '}
              <ChevronDown className="w-4 h-4 md:w-5 md:h-5" data-id="element-132" />
            </button>
          </div>
        </div>
      </section>

      {/* 9. COMPARISON TABLE */}
      <section className="py-10 md:py-16 px-4 bg-white" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto" data-id="element-134">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-[#0a1733] mb-8 md:mb-12" data-id="element-135">
            ¿CUÁNTO CUESTA NO TENER MOTIVACIÓN?
          </h2>

          <div className="overflow-x-auto rounded-xl shadow-xl border border-gray-200" data-id="element-136">
            <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-137">
              <thead data-id="element-138">
                <tr data-id="element-139">
                  <th className="w-1/2 p-4 md:p-6 bg-red-50 text-red-800 font-bold text-base md:text-lg border-b border-red-100 text-center" data-id="element-140">
                    <div className="flex flex-col items-center gap-2" data-id="element-141">
                      <XCircle className="w-6 h-6 md:w-8 md:h-8 text-red-500" data-id="element-142" />
                      Sin MegaPack
                    </div>
                  </th>
                  <th className="w-1/2 p-4 md:p-6 bg-green-50 text-green-800 font-bold text-base md:text-lg border-b border-green-100 text-center" data-id="element-143">
                    <div className="flex flex-col items-center gap-2" data-id="element-144">
                      <CheckCircle2 className="w-6 h-6 md:w-8 md:h-8 text-green-500" data-id="element-145" />
                      Con MegaPack Motivación Total
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-146">
                <TableRow bad="Procrastinación constante que frena tu crecimiento" good="Rutinas claras que te impulsan a actuar cada día" data-id="element-147" />
                <TableRow bad="Falta de energía y distracciones frecuentes" good="Energía sostenida para cumplir tus compromisos" data-id="element-148" />
                <TableRow bad="Sentimiento de culpa y frustración" good="Confianza y satisfacción al alcanzar tus metas" data-id="element-149" />
                <TableRow bad="Estrés y ansiedad sin dirección" good="Herramientas para manejar emociones y mantener el foco" data-id="element-150" />
              </tbody>
            </table>
          </div>

          <div className="text-center mt-8 md:mt-12" data-id="element-151">
            <button onClick={scrollToPricing} className="bg-[#0a1733] hover:bg-[#0d1f47] text-white text-base md:text-lg font-bold py-3 md:py-4 px-6 md:px-8 rounded-full shadow-lg transition-all transform hover:-translate-y-1 inline-flex items-center gap-2" data-id="element-152">
              ELEGIR EL CAMINO DEL ÉXITO{' '}
              <ChevronDown className="w-4 h-4 md:w-5 md:h-5 text-[#e0b73c]" data-id="element-153" />
            </button>
          </div>
        </motion.div>
      </section>

      {/* NEW: SCARCITY / URGENCY SECTION */}
      <section className="py-10 md:py-12 px-4 bg-[#0a1733] text-white relative overflow-hidden border-t-4 border-red-600" data-id="element-154">
        <div className={`absolute inset-0 ${textureClass}`} data-id="element-155"></div>
        <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-156">
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="flex justify-center mb-4" data-id="element-157">
            <Flame className="w-10 h-10 md:w-12 md:h-12 text-red-500 animate-pulse" data-id="element-158" />
          </motion.div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-159">
            🔥 Última oportunidad
          </h2>
          <p className="text-xl md:text-2xl text-[#e0b73c] font-bold mb-8" data-id="element-160">
            No dejes que se acaben los cupos
          </p>

          <div className="bg-[#0d1f47] border border-gray-700 rounded-2xl p-6 md:p-8 mb-8 shadow-2xl relative" data-id="element-161">
            <div className="flex justify-between items-end mb-3" data-id="element-162">
              <span className="font-bold text-gray-300 flex items-center gap-2" data-id="element-163">
                <Timer className="w-5 h-5 text-red-400" data-id="element-164" /> Cupos restantes
              </span>
              <span className="font-black text-2xl text-red-500" data-id="element-165">
                68% TOMADOS
              </span>
            </div>
            <div className="w-full bg-gray-800 rounded-full h-4 md:h-5 overflow-hidden border border-gray-700" data-id="element-166">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} viewport={{
              once: true
            }} className="bg-gradient-to-r from-red-600 to-red-400 h-full rounded-full relative" data-id="element-167">
                <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.2)_50%,transparent_75%,transparent_100%)] bg-[length:20px_20px] animate-[shimmer_1s_linear_infinite]" data-id="element-168"></div>
              </motion.div>
            </div>
            <p className="mt-5 text-sm md:text-base text-gray-400 font-medium" data-id="element-169">
              Cuando se acaben los cupos el precio sube y{' '}
              <span className="text-white font-bold underline decoration-red-500" data-id="element-170">
                NO vuelve a bajar.
              </span>
            </p>
          </div>

          <button onClick={scrollToPricing} className="bg-red-600 hover:bg-red-700 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-full shadow-[0_0_20px_rgba(220,38,38,0.5)] transition-all transform hover:-translate-y-1" data-id="element-171">
            ASEGURAR MI LUGAR AHORA
          </button>
        </div>
      </section>

      {/* 10. PRICING SECTION */}
      <section id="compra" className="py-12 md:py-20 px-4 bg-gray-50 scroll-mt-10" data-id="element-172">
        <div className="max-w-5xl mx-auto" data-id="element-173">
          <h2 className="text-3xl md:text-5xl font-extrabold text-center text-[#0a1733] mb-10 md:mb-16" data-id="element-174">
            ELIGE TU MEGAPACK
          </h2>

          <div className="flex flex-col gap-8 md:gap-12 max-w-3xl mx-auto items-stretch" data-id="element-175">
            {/* Standard Card */}
            <div className={`relative bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col h-full cursor-pointer transition-all duration-300 border-2 ${selectedPlan === 'standard' ? 'border-[#e0b73c] ring-4 ring-[#e0b73c]/20 scale-[1.02]' : 'border-gray-200 hover:border-gray-300'}`} onClick={() => setSelectedPlan('standard')} data-id="element-176">
              <div className="flex justify-between items-start mb-4" data-id="element-177">
                <h3 className="text-xl md:text-2xl font-bold text-[#0a1733]" data-id="element-178">
                  MegaPack Motivación Total
                </h3>
                <div className="mt-1 flex-shrink-0" data-id="element-179">
                  {selectedPlan === 'standard' ? <CheckCircle2 className="w-6 h-6 text-[#e0b73c] fill-[#e0b73c]/10" data-id="element-180" /> : <Circle className="w-6 h-6 text-gray-300" data-id="element-181" />}
                </div>
              </div>
              <ul className="space-y-3 md:space-y-4 mb-8 flex-1 text-sm md:text-base" data-id="element-182">
                <PricingFeature text="6 Tomos + 6 Bonos" data-id="element-183" />
                <PricingFeature text="Acceso inmediato" data-id="element-184" />
                <PricingFeature text="Garantía de 7 días sin riesgos" data-id="element-185" />
              </ul>
              <div className="text-center mb-6" data-id="element-186">
                <span className="text-gray-400 line-through text-lg md:text-xl font-medium block mb-1" data-id="element-187">
                  $59.990
                </span>
                <span className="text-3xl md:text-4xl font-extrabold text-[#0a1733]" data-id="element-188">
                  $19.990
                </span>
              </div>
              <a href="https://checkout.academiaonlinepro.shop/cart/47416313217209:1" onClick={e => e.stopPropagation()} className={`block w-full text-center font-bold py-3 md:py-4 rounded-xl transition-colors border ${selectedPlan === 'standard' ? 'bg-[#0a1733] text-white border-[#0a1733] hover:bg-[#0d1f47]' : 'bg-gray-100 text-[#0a1733] border-gray-300 hover:bg-gray-200'}`} data-id="element-189">
                COMPRAR AHORA
              </a>
            </div>

            {/* Upsell Card (Preselected) with Traveling Light */}
            <div className={`relative rounded-2xl cursor-pointer transition-all duration-300 ${selectedPlan === 'advanced' ? 'scale-[1.02] md:scale-105 z-10' : 'scale-100 opacity-90 hover:opacity-100'}`} onClick={() => setSelectedPlan('advanced')} data-id="element-190">
              {/* Glowing animated border container */}
              <div className={`absolute inset-0 rounded-2xl overflow-hidden ${selectedPlan === 'advanced' ? 'bg-gray-800 shadow-2xl' : 'bg-gray-700 shadow-lg'}`} data-id="element-191">
                {selectedPlan === 'advanced' && <motion.div className="absolute w-[250%] h-[250%] top-[-75%] left-[-75%] bg-[conic-gradient(from_0deg,transparent_0%,transparent_25%,#e0b73c_50%,transparent_75%,transparent_100%)]" animate={{
                rotate: 360
              }} transition={{
                duration: 4,
                repeat: Infinity,
                ease: 'linear'
              }} data-id="element-192" />}
              </div>

              {/* Inner card background to mask the center */}
              <div className="absolute inset-[2px] bg-[#0a1733] rounded-[14px] z-0" data-id="element-193"></div>

              {/* Card Content */}
              <div className="relative z-10 p-6 md:p-8 flex flex-col h-full" data-id="element-194">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#e0b73c] text-[#0a1733] font-bold px-4 md:px-6 py-1 md:py-1.5 rounded-full text-xs md:text-sm uppercase tracking-wider shadow-md whitespace-nowrap" data-id="element-195">
                  ⭐ MÁS ELEGIDA
                </div>

                <div className="flex justify-between items-start mb-4 mt-2" data-id="element-196">
                  <h3 className="text-xl md:text-2xl font-bold text-white pr-2" data-id="element-197">
                    MegaPack Avanzado Éxito Sostenible
                  </h3>
                  <div className="mt-1 flex-shrink-0" data-id="element-198">
                    {selectedPlan === 'advanced' ? <CheckCircle2 className="w-6 h-6 text-[#e0b73c] fill-[#e0b73c]/20" data-id="element-199" /> : <Circle className="w-6 h-6 text-gray-500" data-id="element-200" />}
                  </div>
                </div>

                <ul className="space-y-3 md:space-y-4 mb-8 flex-1 text-gray-300 text-sm md:text-base" data-id="element-201">
                  <PricingFeature text="Todo el contenido del MegaPack Motivación Total" dark data-id="element-202" />
                  <li className="flex items-start gap-2 md:gap-3" data-id="element-203">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#e0b73c] flex-shrink-0 mt-0.5" data-id="element-204" />
                    <div data-id="element-205">
                      <span className="font-semibold text-white" data-id="element-206">
                        2 tomos adicionales especializados:
                      </span>
                      <ul className="mt-2 space-y-2 ml-1 md:ml-2" data-id="element-207">
                        <li className="flex items-start gap-2 text-xs md:text-sm" data-id="element-208">
                          <div className="w-1.5 h-1.5 rounded-full bg-[#e0b73c] mt-1.5 flex-shrink-0" data-id="element-209"></div>
                          <span data-id="element-210">
                            Dominando la Resiliencia Emocional: Mantén tu
                            motivación ante cualquier desafío.
                          </span>
                        </li>
                        <li className="flex items-start gap-2 text-xs md:text-sm" data-id="element-211">
                          <div className="w-1.5 h-1.5 rounded-full bg-[#e0b73c] mt-1.5 flex-shrink-0" data-id="element-212"></div>
                          <span data-id="element-213">
                            Proyección y Crecimiento Continuo: Estrategias para
                            crecer sin agotarte.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <PricingFeature text="Planificador digital interactivo mensual para organizar y evaluar tu progreso." dark data-id="element-214" />
                  <PricingFeature text="Acceso inmediato" dark data-id="element-215" />
                  <PricingFeature text="Garantía de 7 días sin riesgos" dark data-id="element-216" />
                </ul>
                <div className="text-center mb-6" data-id="element-217">
                  <span className="text-gray-400 line-through text-lg md:text-xl font-medium block mb-1" data-id="element-218">
                    $79.990
                  </span>
                  <span className="text-4xl md:text-5xl font-extrabold text-[#e0b73c]" data-id="element-219">
                    $26.990
                  </span>
                </div>
                <a href="https://checkout.academiaonlinepro.shop/cart/47416415781049:1" onClick={e => e.stopPropagation()} className={`block w-full text-center font-bold py-3 md:py-4 rounded-xl transition-all transform text-base md:text-lg ${selectedPlan === 'advanced' ? 'bg-gradient-to-r from-[#e0b73c] to-[#c9a227] hover:from-[#f0c74c] hover:to-[#d9b237] text-[#0a1733] shadow-[0_0_20px_rgba(224,183,60,0.4)] hover:-translate-y-1' : 'bg-gray-700 text-white hover:bg-gray-600'}`} data-id="element-220">
                  COMPRAR MEGAPACK AVANZADO
                </a>
              </div>
            </div>

            {/* NEW SECTION: QUÉ AGREGA EL MEGAPACK AVANZADO (CAROUSEL) */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="mt-8 md:mt-12" data-id="element-221">
              <div className="text-center mb-6" data-id="element-222">
                <h3 className="text-2xl md:text-4xl font-extrabold text-[#0a1733] mb-2" data-id="element-223">
                  🚀 ¿QUÉ AGREGA EL MEGAPACK AVANZADO?
                </h3>
                <p className="text-gray-600 text-sm md:text-base font-medium max-w-2xl mx-auto" data-id="element-224">
                  Todo lo que incluye el MegaPack Motivación Total, MÁS
                  herramientas exclusivas para lograr resultados sostenibles en
                  el tiempo.
                </p>
              </div>

              <AdvancedCarousel data-id="element-225" />
            </motion.div>
          </div>

          <div className="mt-10 md:mt-12 flex justify-center" data-id="element-226">
            <img src="https://cdn.magicpatterns.com/uploads/mjRFCnJrq4SLY189tf2JSD/screencapture-psiquiatriainfantojuvenil-mundodigitalarg-2026-06-10-23_59_55_(1).png" alt="Pagos Seguros" className="h-10 md:h-12 object-cover object-bottom opacity-50 grayscale" style={{
            clipPath: 'inset(90% 0 0 0)'
          }} data-id="element-227" />
            <div className="flex items-center gap-2 text-gray-500 font-medium text-sm md:text-base" data-id="element-228">
              <Lock className="w-4 h-4 md:w-5 md:h-5" data-id="element-229" /> Pago 100% Seguro y
              Encriptado
            </div>
          </div>
        </div>
      </section>

      {/* 11. GARANTÍA */}
      <section className="py-10 md:py-16 px-4 bg-white" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center" data-id="element-231">
          <div className="w-20 h-20 md:w-24 md:h-24 bg-[#0a1733] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg border-4 border-[#e0b73c]" data-id="element-232">
            <ShieldCheck className="w-10 h-10 md:w-12 md:h-12 text-[#e0b73c]" data-id="element-233" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#0a1733] mb-4" data-id="element-234">
            GARANTÍA TOTAL DE SATISFACCIÓN
          </h2>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed px-2" data-id="element-235">
            Pruébalo durante 7 días. Si no notas cambios reales en tu energía y
            motivación, te devolvemos tu dinero. Sin preguntas, sin
            complicaciones.
          </p>
        </motion.div>
      </section>

      {/* 12. FAQ */}
      <section className="py-10 md:py-16 px-4 bg-gray-50" data-id="element-236">
        <div className="max-w-3xl mx-auto" data-id="element-237">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-3xl font-bold text-center text-[#0a1733] mb-8 md:mb-10" data-id="element-238">
            DUDAS FRECUENTES
          </motion.h2>
          <div className="space-y-3 md:space-y-4" data-id="element-239">
            <FAQItem q="❓ ¿Qué pasa si siempre empiezo con motivación, pero la pierdo a los pocos días?" a="Precisamente para eso fue creada esta colección. Aprenderás cómo activar tu motivación interna, desarrollar disciplina sostenible y construir hábitos que te permitan seguir avanzando incluso cuando no tengas ganas." data-id="element-240" />
            <FAQItem q="❓ ¿Y si tengo muchos objetivos, pero nunca logro terminarlos?" a="Los tomos te enseñan un sistema práctico para convertir metas grandes en acciones diarias concretas, evitando la procrastinación y aumentando tu capacidad de ejecución." data-id="element-241" />
            <FAQItem q="❓ ¿Este contenido me ayudará a ser más productivo sin sentirme agotado?" a="Sí. No se trata de trabajar más horas, sino de aprender a enfocar tu energía en lo que realmente genera resultados, eliminando distracciones y optimizando tu tiempo." data-id="element-242" />
            <FAQItem q="❓ ¿Cómo sé cuál tomo debo aplicar primero?" a="La colección está organizada en un orden estratégico. Cada tomo desarrolla una habilidad fundamental que potencia la siguiente, creando una transformación progresiva y fácil de implementar." data-id="element-243" />
            <FAQItem q="❓ ¿Es solo teoría motivacional o incluye herramientas prácticas?" a="Cada tomo contiene estrategias, ejercicios, métodos y sistemas aplicables a la vida real para que puedas pasar de la información a la acción desde el primer día." data-id="element-244" />
            <FAQItem q="❓ ¿Podré aplicar estas enseñanzas aunque tenga poco tiempo disponible?" a="Sí. Las técnicas están diseñadas para integrarse en tu rutina diaria sin necesidad de dedicar horas extra. Pequeñas acciones consistentes generan grandes resultados." data-id="element-245" />
            <FAQItem q="❓ ¿Qué diferencia esta colección de otros cursos de desarrollo personal?" a="No se enfoca únicamente en motivarte temporalmente. Te enseña cómo desarrollar los hábitos, la mentalidad, la organización y la disciplina necesarias para mantener resultados a largo plazo." data-id="element-246" />
            <FAQItem q="❓ ¿Qué resultados puedo esperar si aplico el contenido?" a="Mayor claridad mental, mejor gestión del tiempo, más disciplina, hábitos más sólidos, menos procrastinación y una mayor capacidad para cumplir tus metas personales y profesionales." data-id="element-247" />
          </div>
        </div>
      </section>

      {/* 13. FINAL CTA */}
      <section className="py-16 md:py-20 px-4 bg-[#0a1733] text-white text-center relative overflow-hidden" data-id="element-248">
        <div className={`absolute inset-0 ${textureClass}`} data-id="element-249"></div>
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#e0b73c] via-transparent to-transparent" data-id="element-250"></div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto relative z-10" data-id="element-251">
          <h2 className="text-2xl md:text-5xl font-extrabold mb-4 md:mb-6 text-white px-2" data-id="element-252">
            💥 CONSIGUE TU MEGAPACK AHORA Y TRANSFORMA TU VIDA
          </h2>
          <p className="text-base md:text-xl text-gray-300 mb-8 md:mb-10 px-4" data-id="element-253">
            No dejes pasar más tiempo sintiéndote estancado y sin energía. Tu
            cambio empieza hoy.
          </p>
          <button onClick={scrollToPricing} className="bg-gradient-to-r from-[#e0b73c] to-[#c9a227] hover:from-[#f0c74c] hover:to-[#d9b237] text-[#0a1733] text-lg md:text-2xl font-bold py-4 md:py-5 px-8 md:px-10 rounded-full shadow-[0_0_30px_rgba(224,183,60,0.4)] hover:shadow-[0_0_40px_rgba(224,183,60,0.6)] transition-all transform hover:-translate-y-1" data-id="element-254">
            SÍ, QUIERO EMPEZAR AHORA
          </button>
        </motion.div>
      </section>

      {/* 14. FOOTER */}
      <footer className="bg-[#050b1a] text-gray-400 py-6 md:py-8 px-4 text-center text-xs md:text-sm" data-id="element-255">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-2" data-id="element-256">
          <p data-id="element-257">
            © MegaPack Motivación Total ™ 2026 — Todos los derechos reservados
          </p>
          <p data-id="element-258">contactosoporteacademiaonline.ar@gmail.com</p>
          <p data-id="element-259">@academiaonlinepro.shop</p>
        </div>
      </footer>

      {/* STICKY BOTTOM CTA (Mobile only) */}
      <div className="fixed bottom-0 left-0 right-0 p-3 md:p-4 bg-white border-t border-gray-200 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] md:hidden z-40" data-id="element-260">
        <button onClick={scrollToPricing} className="w-full bg-gradient-to-r from-[#e0b73c] to-[#c9a227] text-[#0a1733] font-bold py-3 rounded-xl shadow-lg text-sm" data-id="element-261">
          COMPRAR AHORA
        </button>
      </div>

      {/* Add custom keyframes for shimmer effect in urgency bar */}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes shimmer {
          0% { background-position: 0 0; }
          100% { background-position: 20px 0; }
        }
      `
    }} data-id="element-262" />
    </div>;
}
// --- Subcomponents ---
function TestimonialCard({
  name,
  role,
  quote,
  rating,
  delay = 0,
  className = ''
}: {
  name: string;
  role: string;
  quote: string;
  rating: number;
  delay?: number;
  className?: string;
}) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const colors = ['bg-blue-600', 'bg-purple-600', 'bg-green-600', 'bg-orange-600', 'bg-pink-600'];
  const colorIndex = name.charCodeAt(0) % colors.length;
  const avatarColor = colors[colorIndex];
  const initial = name.charAt(0).toUpperCase();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay
  }} className={`bg-gray-50 p-5 md:p-6 rounded-xl border-l-4 border-l-[#0a1733] border-y border-r border-gray-100 shadow-sm flex-shrink-0 w-[300px] md:w-[350px] snap-center flex flex-col ${className}`} data-id="element-263">
      <div className="flex items-center gap-3 mb-4" data-id="element-264">
        <div className={`w-12 h-12 rounded-full ${avatarColor} flex items-center justify-center text-white font-bold text-xl flex-shrink-0`} data-id="element-265">
          {initial}
        </div>
        <div data-id="element-266">
          <p className="font-bold text-[#0a1733] text-base" data-id="element-267">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-268">{role}</p>
        </div>
      </div>

      <div className="flex items-center gap-1 text-[#e0b73c] mb-3" data-id="element-269">
        <span className="font-bold text-sm text-[#0a1733] mr-1" data-id="element-270">{rating}</span>
        <div className="flex" data-id="element-271">
          {[...Array(fullStars)].map((_, i) => <Star key={`f-${i}`} className="w-3.5 h-3.5 fill-current" data-id="element-272" />)}
          {hasHalfStar && <StarHalf className="w-3.5 h-3.5 fill-current" data-id="element-273" />}
        </div>
      </div>

      <p className="text-gray-700 italic mb-4 text-sm leading-relaxed flex-grow" data-id="element-274">
        "{quote}"
      </p>

      <div className="flex items-center gap-1.5 text-green-600 text-sm font-medium mt-auto pt-2" data-id="element-275">
        <CheckCircle2 className="w-4 h-4" data-id="element-276" />
        Verificado
      </div>
    </motion.div>;
}
function PainCard({
  icon,
  text,
  className = '',
  delay = 0
}: {
  icon: string;
  text: string;
  className?: string;
  delay?: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay
  }} className={`bg-[#0d1f47] relative overflow-hidden p-5 md:p-6 rounded-xl border border-[#e0b73c]/20 flex items-center gap-3 md:gap-4 ${className}`} data-id="element-277">
      <div className={`absolute inset-0 ${textureClass} opacity-50`} data-id="element-278"></div>
      <span className="text-2xl md:text-3xl relative z-10" data-id="element-279">{icon}</span>
      <p className="text-white font-medium text-sm md:text-base relative z-10" data-id="element-280">
        {text}
      </p>
    </motion.div>;
}
function TargetAudienceItem({
  text
}: {
  text: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true
  }} className="flex items-start gap-3 md:gap-4 p-3 md:p-4 bg-gray-50 rounded-xl border border-gray-100" data-id="element-281">
      <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-[#e0b73c] flex-shrink-0 mt-0.5" data-id="element-282" />
      <p className="text-gray-700 font-medium text-sm md:text-base" data-id="element-283">{text}</p>
    </motion.div>;
}
function StatItem({
  number,
  text
}: {
  number: string;
  text: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.9
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} data-id="element-284">
      <p className="text-3xl md:text-5xl font-extrabold text-[#e0b73c] mb-1 md:mb-2" data-id="element-285">
        {number}
      </p>
      <p className="text-gray-300 font-medium uppercase tracking-wide text-xs md:text-sm" data-id="element-286">
        {text}
      </p>
    </motion.div>;
}
function TomoCard({
  num,
  title,
  desc,
  icon,
  image,
  delay = 0
}: {
  num: string;
  title: string;
  desc: string;
  icon: React.ReactNode;
  image?: string;
  delay?: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay
  }} className={`bg-[#0a1733] rounded-2xl shadow-lg overflow-hidden border transition-all duration-300 ${isOpen ? 'border-[#e0b73c]' : 'border-[#e0b73c]/20'}`} data-id="element-287">
      <button onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} className="w-full text-left block relative group focus:outline-none" data-id="element-288">
        {/* Banner image (or styled fallback for tomos without an image) */}
        {image ? <div className="overflow-hidden" data-id="element-289">
            <motion.img src={image} alt={`Tomo ${num}: ${title}`} className="w-full aspect-[2/1] object-cover" whileHover={{
          scale: 1.03
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} data-id="element-290" />
          </div> : <div className="w-full aspect-[2/1] bg-gradient-to-br from-[#0a1733] to-[#0d1f47] flex items-center p-6 md:p-8 relative overflow-hidden" data-id="element-291">
            <div className={`absolute inset-0 ${textureClass} opacity-40`} data-id="element-292"></div>
            <div className="relative z-10 flex items-center gap-4" data-id="element-293">
              <div className="bg-[#e0b73c] p-3 md:p-4 rounded-2xl text-[#0a1733]" data-id="element-294">
                {icon}
              </div>
              <div data-id="element-295">
                <div className="text-xs md:text-sm font-bold text-[#e0b73c] mb-1 uppercase tracking-wider" data-id="element-296">
                  Tomo {num}
                </div>
                <h4 className="text-lg md:text-2xl font-extrabold text-white leading-tight" data-id="element-297">
                  {title}
                </h4>
              </div>
            </div>
          </div>}

        {/* Toggle bar with sliding chevron */}
        <div className="flex items-center justify-between px-4 md:px-5 py-3 bg-[#0d1f47] border-t border-[#e0b73c]/20" data-id="element-298">
          <span className="text-sm md:text-base font-semibold text-white" data-id="element-299">
            {isOpen ? 'Cerrar descripción' : 'Ver descripción'}
          </span>
          <motion.div animate={{
          y: isOpen ? 0 : [0, 4, 0],
          rotate: isOpen ? 180 : 0
        }} transition={isOpen ? {
          rotate: {
            duration: 0.3
          }
        } : {
          y: {
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="bg-[#e0b73c] rounded-full p-1.5" data-id="element-300">
            <ChevronDown className="w-4 h-4 md:w-5 md:h-5 text-[#0a1733]" data-id="element-301" />
          </motion.div>
        </div>
      </button>

      {/* Expandable description */}
      <AnimatePresence data-id="element-302">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.35,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-303">
            <p className="px-4 md:px-5 py-4 text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-304">
              {desc}
            </p>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
function BonoCard({
  title,
  desc,
  icon,
  delay = 0
}: {
  title: string;
  desc: string;
  icon: React.ReactNode;
  delay?: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true
  }} transition={{
    delay
  }} whileHover={{
    scale: 1.02
  }} className="bg-[#0a1733] p-4 md:p-6 rounded-xl border border-[#e0b73c]/30 flex items-start gap-3 md:gap-4 hover:bg-[#0d1f47] transition-all relative overflow-hidden" data-id="element-305">
      <div className={`absolute inset-0 ${textureClass} opacity-30`} data-id="element-306"></div>
      <div className="bg-[#e0b73c]/10 p-2 md:p-3 rounded-lg text-[#e0b73c] relative z-10" data-id="element-307">
        {icon}
      </div>
      <div className="relative z-10" data-id="element-308">
        <h4 className="text-base md:text-lg font-bold text-white mb-1" data-id="element-309">
          {title}
        </h4>
        <p className="text-gray-400 text-xs md:text-sm" data-id="element-310">{desc}</p>
      </div>
    </motion.div>;
}
function TableRow({
  bad,
  good
}: {
  bad: string;
  good: string;
}) {
  return <tr data-id="element-311">
      <td className="p-3 md:p-4 bg-red-50/50 text-red-900 border-r border-gray-200 text-xs md:text-base" data-id="element-312">
        {bad}
      </td>
      <td className="p-3 md:p-4 bg-green-50/50 text-green-900 font-medium text-xs md:text-base" data-id="element-313">
        {good}
      </td>
    </tr>;
}
function PricingFeature({
  text,
  dark = false
}: {
  text: string;
  dark?: boolean;
}) {
  return <li className="flex items-start gap-2 md:gap-3" data-id="element-314">
      <CheckCircle2 className={`w-4 h-4 md:w-5 md:h-5 flex-shrink-0 mt-0.5 ${dark ? 'text-[#e0b73c]' : 'text-green-500'}`} data-id="element-315" />
      <span className={dark ? 'text-white font-medium' : 'text-gray-700 font-medium'} data-id="element-316">
        {text}
      </span>
    </li>;
}
function FAQItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-317">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-4 md:px-6 py-3 md:py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-318">
        <span className="font-bold text-[#0a1733] text-sm md:text-base pr-4" data-id="element-319">
          {q}
        </span>
        <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-320" />
      </button>
      <AnimatePresence data-id="element-321">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-322">
            <div className="px-4 md:px-6 pb-3 md:pb-4 text-gray-600 text-xs md:text-sm leading-relaxed border-t border-gray-100 pt-3 md:pt-4" data-id="element-323">
              {a}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
function TestimonialCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = [{
    name: 'Ana M.',
    role: 'Emprendedora · Ciudad de México',
    quote: 'En solo 10 días noté un cambio real: más enfoque, menos distracciones y energía para cumplir mis tareas sin sentirme agotada. Las rutinas son súper prácticas y fáciles de aplicar.',
    rating: 5
  }, {
    name: 'Luis R.',
    role: 'Estudiante Universitario · Bogotá',
    quote: 'Antes procrastinaba mucho y me sentía frustrado. Con el MegaPack aprendí a vencer la flojera y a organizar mi día para estar motivado siempre. Ahora estudio con ganas y mejores resultados.',
    rating: 4.5
  }, {
    name: 'Carla P.',
    role: 'Freelancer · Buenos Aires',
    quote: 'La parte de manejo emocional me ayudó a no rendirme en días difíciles. Además, el planificador digital me mantiene en camino y viendo mis avances. Súper recomendable.',
    rating: 5
  }, {
    name: 'Martín G.',
    role: 'Emprendedor · Córdoba',
    quote: 'Increíble cómo me cambió la perspectiva. Dejé de dar vueltas y empecé a ejecutar. Mi productividad se disparó en la primera semana.',
    rating: 4.5
  }, {
    name: 'Valentina R.',
    role: 'Diseñadora · La Plata',
    quote: 'El manejo del estrés y la ansiedad por no avanzar era terrible. Las rutinas me devolvieron la paz mental y las ganas de crear.',
    rating: 5
  }];
  const nextSlide = () => {
    setCurrentIndex(prev => prev === testimonials.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => prev === 0 ? testimonials.length - 1 : prev - 1);
  };
  return <div className="relative w-full max-w-lg mx-auto" data-id="element-324">
      <div className="overflow-hidden relative pb-8 px-2" data-id="element-325">
        <AnimatePresence initial={false} mode="wait" data-id="element-326">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -50
        }} transition={{
          duration: 0.3
        }} className="w-full" data-id="element-327">
            <TestimonialCard name={testimonials[currentIndex].name} role={testimonials[currentIndex].role} quote={testimonials[currentIndex].quote} rating={testimonials[currentIndex].rating} className="w-full mx-auto" data-id="element-328" />
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Navigation Arrows */}
      <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-12 bg-white shadow-md hover:bg-gray-50 text-[#0a1733] p-2 rounded-full transition-colors z-20" data-id="element-329">
        <ChevronLeft className="w-5 h-5" data-id="element-330" />
      </button>
      <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-12 bg-white shadow-md hover:bg-gray-50 text-[#0a1733] p-2 rounded-full transition-colors z-20" data-id="element-331">
        <ChevronRight className="w-5 h-5" data-id="element-332" />
      </button>

      {/* Pagination Dots */}
      <div className="flex justify-center items-center gap-2 mt-2" data-id="element-333">
        {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-8 bg-[#e0b73c]' : 'w-2 bg-gray-300 hover:bg-gray-400'}`} data-id="element-334" />)}
      </div>
    </div>;
}
function AdvancedCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slides = [{
    title: '2 Tomos Premium Adicionales',
    image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?auto=format&fit=crop&w=800&q=80',
    content: <div className="space-y-4" data-id="element-335">
          <div data-id="element-336">
            <h5 className="font-bold text-[#e0b73c] flex items-center gap-2 mb-1 text-sm md:text-base" data-id="element-337">
              📘 Dominando la Resiliencia Emocional
            </h5>
            <p className="text-white text-xs md:text-sm leading-relaxed" data-id="element-338">
              Aprende a mantener tu motivación incluso en momentos difíciles,
              superar bloqueos mentales y recuperar el enfoque cuando aparecen
              obstáculos o frustraciones.
            </p>
          </div>
          <div data-id="element-339">
            <h5 className="font-bold text-[#e0b73c] flex items-center gap-2 mb-1 text-sm md:text-base" data-id="element-340">
              📘 Proyección y Crecimiento Continuo
            </h5>
            <p className="text-white text-xs md:text-sm leading-relaxed" data-id="element-341">
              Construye una estrategia de crecimiento personal y profesional a
              largo plazo para evitar estancarte y seguir avanzando sin perder
              energía ni claridad.
            </p>
          </div>
        </div>
  }, {
    title: 'Planificador Digital Interactivo Premium',
    image: 'https://images.unsplash.com/photo-1512314889357-e157c22f938d?auto=format&fit=crop&w=800&q=80',
    content: <div data-id="element-342">
          <p className="text-white text-sm md:text-base mb-3 font-medium" data-id="element-343">
            Organiza tus objetivos, tareas y hábitos en un solo lugar.
          </p>
          <ul className="space-y-2" data-id="element-344">
            <li className="flex items-start gap-2 text-white text-xs md:text-sm" data-id="element-345">
              <div className="w-1.5 h-1.5 rounded-full bg-[#e0b73c] mt-1.5 flex-shrink-0" data-id="element-346"></div>
              <span data-id="element-347">Planificación mensual y semanal.</span>
            </li>
            <li className="flex items-start gap-2 text-white text-xs md:text-sm" data-id="element-348">
              <div className="w-1.5 h-1.5 rounded-full bg-[#e0b73c] mt-1.5 flex-shrink-0" data-id="element-349"></div>
              <span data-id="element-350">Seguimiento de hábitos y progreso.</span>
            </li>
            <li className="flex items-start gap-2 text-white text-xs md:text-sm" data-id="element-351">
              <div className="w-1.5 h-1.5 rounded-full bg-[#e0b73c] mt-1.5 flex-shrink-0" data-id="element-352"></div>
              <span data-id="element-353">Evaluación de resultados.</span>
            </li>
            <li className="flex items-start gap-2 text-white text-xs md:text-sm" data-id="element-354">
              <div className="w-1.5 h-1.5 rounded-full bg-[#e0b73c] mt-1.5 flex-shrink-0" data-id="element-355"></div>
              <span data-id="element-356">Herramientas para mantener la constancia.</span>
            </li>
          </ul>
        </div>
  }, {
    title: 'Sistema Completo para el Éxito Sostenible',
    image: 'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?auto=format&fit=crop&w=800&q=80',
    content: <div className="space-y-4" data-id="element-357">
          <p className="text-white text-xs md:text-sm leading-relaxed" data-id="element-358">
            Mientras el MegaPack Motivación Total te ayuda a activar tu energía
            y disciplina, la versión Avanzada te enseña cómo mantener esos
            resultados durante meses y años.
          </p>
          <p className="text-[#e0b73c] font-bold text-xs md:text-sm" data-id="element-359">
            🔥 Ideal para quienes quieren un cambio real y duradero, no solo un
            impulso temporal.
          </p>
          <p className="text-white font-semibold text-xs md:text-sm" data-id="element-360">
            ⭐ Por solo una pequeña diferencia de precio obtienes el sistema más
            completo de desarrollo personal, productividad y motivación de toda
            la colección.
          </p>
        </div>
  }];
  const nextSlide = () => {
    setCurrentIndex(prev => prev === slides.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => prev === 0 ? slides.length - 1 : prev - 1);
  };
  return <div className="relative w-full max-w-4xl mx-auto bg-[#0a1733] rounded-2xl overflow-hidden shadow-2xl border border-[#0d1f47]" data-id="element-361">
      <div className="relative h-[450px] md:h-[500px] w-full" data-id="element-362">
        <AnimatePresence initial={false} mode="wait" data-id="element-363">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -50
        }} transition={{
          duration: 0.3
        }} className="absolute inset-0" data-id="element-364">
            {/* Background Image with Gradient Overlay */}
            <div className="absolute inset-0" data-id="element-365">
              <img src={slides[currentIndex].image} alt={slides[currentIndex].title} className="w-full h-full object-cover opacity-40" data-id="element-366" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1733] via-[#0a1733]/80 to-transparent" data-id="element-367"></div>
            </div>

            {/* Content */}
            <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-12 z-10" data-id="element-368">
              <div className="inline-block bg-[#e0b73c] text-[#0a1733] font-bold px-4 py-1.5 rounded-full text-xs md:text-sm mb-4 w-max shadow-md" data-id="element-369">
                ⭐ INCLUIDO EN AVANZADO
              </div>
              <h4 className="text-2xl md:text-3xl font-extrabold text-white mb-4" data-id="element-370">
                {slides[currentIndex].title}
              </h4>
              <div className="max-w-2xl" data-id="element-371">{slides[currentIndex].content}</div>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Navigation Arrows */}
        <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 bg-[#0d1f47]/80 hover:bg-[#0d1f47] text-white p-2 md:p-3 rounded-full backdrop-blur-sm transition-colors z-20" data-id="element-372">
          <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" data-id="element-373" />
        </button>
        <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 bg-[#0d1f47]/80 hover:bg-[#0d1f47] text-white p-2 md:p-3 rounded-full backdrop-blur-sm transition-colors z-20" data-id="element-374">
          <ChevronRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-375" />
        </button>
      </div>

      {/* Pagination Dots */}
      <div className="bg-[#050b1a] py-4 flex justify-center items-center gap-2" data-id="element-376">
        {slides.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-8 bg-[#e0b73c]' : 'w-2 bg-gray-600 hover:bg-gray-400'}`} data-id="element-377" />)}
        <span className="text-gray-400 text-xs ml-4 font-medium" data-id="element-378">
          {currentIndex + 1} / {slides.length} · DESLIZÁ PARA VER MÁS
        </span>
      </div>
    </div>;
}